$('.video-gallery-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  variableWidth: true,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
  ],
});

const exploreSlider = $('.explore-video-slider');
exploreSlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  centerMode: true,
  variableWidth: true,
  nextArrow: '<button type="button" class="arrow-next"><i class="fa-solid fa-angle-right"></i></button>',
  prevArrow: '<button type="button" class="arrow-prev"><i class="fa-solid fa-angle-left"></i></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        centerMode: false,
      },
    },
    {
      breakpoint: 576,
      settings: {
        centerMode: true,
      },
    },
  ],
});

// Video page other videos
$('.other-videos__header').click((e) => {
  e.stopPropagation();
  $(e.target).toggleClass('active').siblings('.other-videos__videos').slideToggle(200);
});

// Copy to clipboard
const shareInput = document.querySelector('.share-copy input');
const shareCopy = document.querySelector('.share-copy .copy');
const modalIndicator = document.querySelector('.modal-indicator');

if (shareCopy) shareCopy.addEventListener('click', copyToClipboard);

function copyToClipboard() {
  shareInput.select();
  document.execCommand('copy');
  modalIndicator.classList.add('show');

  setTimeout(() => {
    modalIndicator.classList.remove('show');
  }, 3000);
}
